export const roundToThree = (value) => {
    const number = Number(value);

    if (isNaN(number)) {
        console.error('Input is not a valid number:', value);
        return value; // Return the original input or handle the error as needed
    }

    let roundedNumber = number.toFixed(3);
    roundedNumber = parseFloat(roundedNumber);
    let numberAsString = roundedNumber.toString().replace('.', ',');
    numberAsString = numberAsString.replace(/,0+$/, '');

    return numberAsString;
};
